module.exports = __webpack_public_path__ + "img/footer_logo.995527f0.png";